const ComingSoonPage = () => {
    return (
        <div/>
    )
}

export default ComingSoonPage;